import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Router from "./router";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element #root was not found.");
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);
